// Before modifying a Segment Event name, keep in mind it may be an Optimizely experiment involved.
// If that is the case, please be aware that having a mismatch between a Segment Event name
// and an Optimizely Event name, will stop Segment from sending information to Optimizely.
// https://segment.com/docs/connections/destinations/catalog/optimizely-web/#optimizely-x-web

const SELECT_PAYMENT_TYPE = 'Select Payment Type';
const FORM_INPUT_EVENT = 'Form Input';
const FORM_TYPE_INTRO_PRODUCT = 'Intro Product Acquisition';
const PERSONAL_INFO_INPUT_FIELD = 'Personal Information';
const SHIPPING_INFO_INPUT_FIELD = 'Shipping Information';
const PAYMENT_INFO_INPUT_FIELD = 'Payment Information';

export {
  SELECT_PAYMENT_TYPE,
  FORM_INPUT_EVENT,
  FORM_TYPE_INTRO_PRODUCT,
  PERSONAL_INFO_INPUT_FIELD,
  SHIPPING_INFO_INPUT_FIELD,
  PAYMENT_INFO_INPUT_FIELD,
};
